<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [dataLabels]="chartOptions.dataLabels!"
        [plotOptions]="chartOptions.plotOptions!"
        [title]="chartOptions.title!"
        [legend]="chartOptions.legend!"
    ></apx-chart>
</div>